// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3xXT_","location":"Header_location__3coD9"};